import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevronDown", "chevronUp", "collapse"]

  connect() {
    // Listen for Bootstrap collapse events
    this.collapseTarget.addEventListener('show.bs.collapse', () => {
      this.showUpChevron()
    })
    
    this.collapseTarget.addEventListener('hide.bs.collapse', () => {
      this.showDownChevron()
    })
  }

  toggleChevron() {
    // Toggle chevron icons when button is clicked
    if (this.chevronDownTarget.classList.contains('d-none')) {
      this.showUpChevron()
    } else {
      this.showDownChevron()
    }
  }

  showUpChevron() {
    this.chevronDownTarget.classList.add('d-none')
    this.chevronUpTarget.classList.remove('d-none')
  }

  showDownChevron() {
    this.chevronUpTarget.classList.add('d-none')
    this.chevronDownTarget.classList.remove('d-none')
  }
}
